export enum actionTypes {
  //FetchCommercialUsers
  FETCH_COMMERCIAL_USERS_REQUEST = "FETCH_COMMERCIAL_USERS_REQUEST",
  FETCH_COMMERCIAL_USERS_SUCCESS = "FETCH_COMMERCIAL_USERS_SUCCESS",
  FETCH_COMMERCIAL_USERS_FAIL = "FETCH_COMMERCIAL_USERS_FAIL",
  //FetchCommercialUsers
  FETCH_COMMERCIAL_USER_BY_ID_REQUEST = "FETCH_COMMERCIAL_USER_BY_ID_REQUEST",
  FETCH_COMMERCIAL_USER_BY_ID_SUCCESS = "FETCH_COMMERCIAL_USER_BY_ID_SUCCESS",
  FETCH_COMMERCIAL_USER_BY_ID_FAIL = "FETCH_COMMERCIAL_USER_BY_ID_FAIL",
  //FetchCommercialUserProfileByUserID
  FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_REQUEST = "FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_REQUEST",
  FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_SUCCESS = "FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_SUCCESS",
  FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_FAIL = "FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_FAIL",
  //FetchCommercialActiveUsers
  FETCH_COMMERCIAL_ACTIVE_USERS_REQUEST = "FETCH_COMMERCIAL_ACTIVE_USERS_REQUEST",
  FETCH_COMMERCIAL_ACTIVE_USERS_SUCCESS = "FETCH_COMMERCIAL_ACTIVE_USERS_SUCCESS",
  FETCH_COMMERCIAL_ACTIVE_USERS_FAIL = "FETCH_COMMERCIAL_ACTIVE_USERS_FAIL",
  //FetchCommercialNewRegister
  FETCH_COMMERCIAL_NEW_REGISTER_REQUEST = "FETCH_COMMERCIAL_NEW_REGISTER_REQUEST",
  FETCH_COMMERCIAL_NEW_REGISTER_SUCCESS = "FETCH_COMMERCIAL_NEW_REGISTER_SUCCESS",
  FETCH_COMMERCIAL_NEW_REGISTER_FAIL = "FETCH_COMMERCIAL_NEW_REGISTER_FAIL",
  //CheckForExistingCommercialUserByEmailSuccessAction
  CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_REQUEST = "CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_REQUEST",
  CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_SUCCESS = "CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_SUCCESS",
  CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_FAIL = "CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_FAIL",
  CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_REQUEST = "CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_REQUEST",
  CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_SUCCESS = "CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_SUCCESS",
  CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_FAIL = "CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_FAIL",
  //CreateCommercialUser
  CREATE_COMMERCIAL_USER_REQUEST = "CREATE_COMMERCIAL_USER_REQUEST",
  CREATE_COMMERCIAL_USER_SUCCESS = "CREATE_COMMERCIAL_USER_SUCCESS",
  CREATE_COMMERCIAL_USER_FAIL = "CREATE_COMMERCIAL_USER_FAIL",
  //UpdateCommercialUser
  UPDATE_COMMERCIAL_USER_REQUEST = "UPDATE_COMMERCIAL_USER_REQUEST",
  UPDATE_COMMERCIAL_USER_SUCCESS = "UPDATE_COMMERCIAL_USER_SUCCESS",
  UPDATE_COMMERCIAL_USER_FAIL = "UPDATE_COMMERCIAL_USER_FAIL",
  //ResetCommercialUserPassword
  RESET_COMMERCIAL_USER_PASSWORD_REQUEST = "RESET_COMMERCIAL_USER_PASSWORD_REQUEST",
  RESET_COMMERCIAL_USER_PASSWORD_SUCCESS = "RESET_COMMERCIAL_USER_PASSWORD_SUCCESS",
  RESET_COMMERCIAL_USER_PASSWORD_FAIL = "RESET_COMMERCIAL_USER_PASSWORD_FAIL",
  //UPDATECommercialUserStatus
  UPDATE_COMMERCIAL_USER_STATUS_REQUEST = "UPDATE_COMMERCIAL_USER_STATUS_REQUEST",
  UPDATE_COMMERCIAL_USER_STATUS_SUCCESS = "UPDATE_COMMERCIAL_USER_STATUS_SUCCESS",
  UPDATE_COMMERCIAL_USER_STATUS_FAIL = "UPDATE_COMMERCIAL_USER_STATUS_FAIL",
  RESET_COMMERCIAL_DETAILS = "RESET_COMMERCIAL_DETAILS",

  FILTER_USER_REQUEST = 'FILTER_USER_REQUEST',
  FILTER_USER_SUCCESS = 'FILTER_USER_SUCCESS',
  FILTER_USER_FAIL = 'FILTER_USER_FAIL'
}

export interface GenericGroupStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface CommercialUserProps {
  email: string;
  id: string;
  mobile_no: string;
  status: string;
  user_identifier: string;
  user_profile: CommercialUserProfileProps;
  
}

export interface CommercialActiveUserProps{
  year:string;
  user_id: string;
  total_count: string;
  month:string;
  activity_counts:ActivityCounts
  user:CommercialUserProps
}
export interface ActivityCounts {
  others:string;
  video_watched: string;
   CheyChey:string;
}

export interface CommercialUserProfileProps {
  gender: string;
  id: string;
  name: string;
  profile_picture: string;
}
export interface RegisteredCommercialUserProps {
  user: CommercialUserProps;
  profile: CommercialUserProfileProps;
}
export interface CommerciaSignUpInput {
  mobile_no: string;
  name: string;
  gender: string;
  password?: string;
  confirm_password?: string;
  email: string;
}
export interface CommerciaSignUpInputError {
  mobile_no?: string;
  name?: string;
  gender?: string;
  password?: string;
  confirm_password?: string;
  email?: string;
}

export interface ResetCommercialPasswordInput {
  user_id: string;
  password: string;
  confirm_password: string;
}

export interface ResetCommercialPasswordInputError {
  password?: string;
  confirm_password?: string;
}
export interface CommercialDateRangeInput {
  from_date: string;
  to_date: string;
}
export interface CommercialDateRangeError {
  from_date?: string;
  to_date?: string;
}
export interface FilterUserProps {
  user_id:string;
  exist_user:boolean
}
export interface FilterUserInput {
  field:string;
  value:string
}

//FetchCommercialUsers
export interface FetchCommercialUsersRequestAction {
  type: actionTypes.FETCH_COMMERCIAL_USERS_REQUEST;
}

export interface FetchCommercialUsersSuccessAction {
  type: actionTypes.FETCH_COMMERCIAL_USERS_SUCCESS;
  payload: CommercialUserProps[];
}

export interface FetchCommercialUsersFailureAction {
  type: actionTypes.FETCH_COMMERCIAL_USERS_FAIL;
  payload: string;
}
//FetchCommercialUserByIdByID
export interface FetchCommercialUserByIdRequestAction {
  type: actionTypes.FETCH_COMMERCIAL_USER_BY_ID_REQUEST;
}

export interface FetchCommercialUserByIdSuccessAction {
  type: actionTypes.FETCH_COMMERCIAL_USER_BY_ID_SUCCESS;
  payload: CommercialUserProps;
}

export interface FetchCommercialUserByIdFailureAction {
  type: actionTypes.FETCH_COMMERCIAL_USER_BY_ID_FAIL;
  payload: string;
}
//FetchCommercialUsersprofileBYuserID
export interface FetchCommercialUserProfileByUserIdRequestAction {
  type: actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_REQUEST;
}

export interface FetchCommercialUserProfileByUserIdSuccessAction {
  type: actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_SUCCESS;
  payload: CommercialUserProfileProps;
}

export interface FetchCommercialUserProfileByUserIdFailureAction {
  type: actionTypes.FETCH_COMMERCIAL_USER_PROFILE_BY_USER_ID_FAIL;
  payload: string;
}
//FetchCommercialActiveUsers
export interface FetchCommercialActiveUsersRequestAction {
  type: actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_REQUEST;
}

export interface FetchCommercialActiveUsersSuccessAction {
  type: actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_SUCCESS;
  payload: CommercialUserProps[];
}

export interface FetchCommercialActiveUsersFailureAction {
  type: actionTypes.FETCH_COMMERCIAL_ACTIVE_USERS_FAIL;
  payload: string;
}
//FetchCommercialNewRegister
export interface FetchCommercialNewRegisterRequestAction {
  type: actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_REQUEST;
}

export interface FetchCommercialNewRegisterSuccessAction {
  type: actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_SUCCESS;
  payload: CommercialUserProps[];
}

export interface FetchCommercialNewRegisterFailureAction {
  type: actionTypes.FETCH_COMMERCIAL_NEW_REGISTER_FAIL;
  payload: string;
}
//CheckForExistingCommercialUserByMobile
export interface CheckForExistingCommercialUserByMobileRequestAction {
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_REQUEST;
}
export interface CheckForExistingCommercialUserByMobileSuccessAction {
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_SUCCESS;
}

export interface CheckForExistingCommercialUserByMobileFailAction {
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_MOBILE_FAIL;
  payload: string;
}

//CheckForExistingCommercialUserByEmail
export interface CheckForExistingCommercialUserByEmailRequestAction {
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_REQUEST;
}
export interface CheckForExistingCommercialUserByEmailSuccessAction {
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_SUCCESS;
}

export interface CheckForExistingCommercialUserByEmailFailAction {
  type: actionTypes.CHECK_FOR_EXISTING_COMMERCIAL_USER_BY_EMAIL_FAIL;
  payload: string;
}

export interface ResetCommercialDetails {
  type: actionTypes.RESET_COMMERCIAL_DETAILS;
}
//CreateCommercialUser
export interface CreateCommercialUserRequestAction {
  type: actionTypes.CREATE_COMMERCIAL_USER_REQUEST;
}
export interface CreateCommercialUserSuccessAction {
  type: actionTypes.CREATE_COMMERCIAL_USER_SUCCESS;
  payload: CommercialUserProps;
}
export interface CreateCommercialUserFailAction {
  type: actionTypes.CREATE_COMMERCIAL_USER_FAIL;
  payload: string;
}
//UpdateCommercialUser
export interface UpdateCommercialUserRequestAction {
  type: actionTypes.UPDATE_COMMERCIAL_USER_REQUEST;
}
export interface UpdateCommercialUserSuccessAction {
  type: actionTypes.UPDATE_COMMERCIAL_USER_SUCCESS;
  payload: CommercialUserProps;
}
export interface UpdateCommercialUserFailAction {
  type: actionTypes.UPDATE_COMMERCIAL_USER_FAIL;
  payload: string;
}
//ResetCommercialUserPassword
export interface ResetCommercialUserPasswordRequestAction {
  type: actionTypes.RESET_COMMERCIAL_USER_PASSWORD_REQUEST;
}
export interface ResetCommercialUserPasswordSuccessAction {
  type: actionTypes.RESET_COMMERCIAL_USER_PASSWORD_SUCCESS;
  payload: string;
}
export interface ResetCommercialUserPasswordFailAction {
  type: actionTypes.RESET_COMMERCIAL_USER_PASSWORD_FAIL;
  payload: string;
}
//UpdateCommercialUserStatus
export interface UpdateCommercialUserStatusRequestAction {
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_REQUEST;
}
export interface UpdateCommercialUserStatusSuccessAction {
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_SUCCESS;
  payload: CommercialUserProps;
}
export interface UpdateCommercialUserStatusFailAction {
  type: actionTypes.UPDATE_COMMERCIAL_USER_STATUS_FAIL;
  payload: string;
}
export interface FilterUserRequestAction {
  type: actionTypes.FILTER_USER_REQUEST;
}
export interface FilterUserSuccessAction {
  type: actionTypes.FILTER_USER_SUCCESS;
  payload: FilterUserProps;
}
export interface FilterUserFailAction {
  type: actionTypes.FILTER_USER_FAIL;
  payload: string;
}

export type CommercialUserActions =
  | FetchCommercialUsersRequestAction
  | FetchCommercialUsersSuccessAction
  | FetchCommercialUsersFailureAction
  | FetchCommercialUserByIdRequestAction
  | FetchCommercialUserByIdSuccessAction
  | FetchCommercialUserByIdFailureAction
  | FetchCommercialUserProfileByUserIdRequestAction
  | FetchCommercialUserProfileByUserIdSuccessAction
  | FetchCommercialUserProfileByUserIdFailureAction
  | FetchCommercialActiveUsersRequestAction
  | FetchCommercialActiveUsersSuccessAction
  | FetchCommercialActiveUsersFailureAction
  | FetchCommercialNewRegisterRequestAction
  | FetchCommercialNewRegisterSuccessAction
  | FetchCommercialNewRegisterFailureAction
  | CreateCommercialUserRequestAction
  | CreateCommercialUserSuccessAction
  | CreateCommercialUserFailAction
  | UpdateCommercialUserRequestAction
  | UpdateCommercialUserSuccessAction
  | UpdateCommercialUserFailAction
  | UpdateCommercialUserStatusRequestAction
  | UpdateCommercialUserStatusSuccessAction
  | UpdateCommercialUserStatusFailAction
  | ResetCommercialUserPasswordRequestAction
  | ResetCommercialUserPasswordSuccessAction
  | ResetCommercialUserPasswordFailAction
  | CheckForExistingCommercialUserByMobileRequestAction
  | CheckForExistingCommercialUserByMobileSuccessAction
  | CheckForExistingCommercialUserByMobileFailAction
  | CheckForExistingCommercialUserByEmailRequestAction
  | CheckForExistingCommercialUserByEmailSuccessAction
  | CheckForExistingCommercialUserByEmailFailAction
  | ResetCommercialDetails
  |FilterUserRequestAction
  |FilterUserSuccessAction
  |FilterUserFailAction;
